'use client';

import { useRouter } from 'next/navigation';

const ErrorPage = () => {
  const router = useRouter();

  return (
    <main className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto flex min-h-screen flex-col items-center justify-center px-4 py-12 md:flex-row md:gap-12">
        {/* SVG Illustration - No image required */}
        <div className="mb-10 md:mb-0 md:w-1/2">
          <div className="mx-auto w-full max-w-xs">
            <svg
              viewBox="0 0 200 200"
              className="w-full text-red-500"
              aria-hidden="true"
            >
              {/* Broken heart icon */}

              <path
                fill="none"
                stroke="currentColor"
                strokeWidth="8"
                strokeLinecap="round"
                d="M60 60l80 80m0-80l-80 80"
              />
              {/* 404 text */}
              <text
                x="100"
                y="120"
                textAnchor="middle"
                fontSize="32"
                fontWeight="bold"
                fill="currentColor"
              >
                404
              </text>
            </svg>
          </div>
        </div>

        {/* Content Section */}
        <div className="md:w-1/2">
          <div className="text-center md:text-left">
            <span className="mb-3 inline-block rounded-full bg-red-100 px-4 py-1.5 text-sm font-medium text-red-600">
              Temporary Disruption
            </span>
            <h5 className="text-4xl font-bold text-gray-900 sm:text-5xl">
              Your Path to Wellness Hit a Snag
            </h5>
            <p className="mt-4 text-lg text-gray-600">
              We&rsquo;re experiencing technical difficulties, but your recovery
              journey is still our priority.
            </p>
            <p className="mt-2 text-gray-600">
              Try one of these options to get back on track:
            </p>

            {/* Action Buttons */}
            <div className="mt-8 flex flex-col gap-4 sm:flex-row">
              <button
                onClick={() => router.refresh()}
                className="flex items-center justify-center gap-2 rounded-lg bg-blue-600 px-6 py-3 font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                <RefreshIcon />
                Try Again
              </button>
              <button
                onClick={() => router.push('/')}
                className="flex items-center justify-center gap-2 rounded-lg border border-blue-600 px-6 py-3 font-medium text-blue-600 transition-colors hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                <HomeIcon />
                Homepage
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

// Icons (no external dependencies)
const RefreshIcon = () => (
  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
      clipRule="evenodd"
    />
  </svg>
);

const HomeIcon = () => (
  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
  </svg>
);

const MailIcon = () => (
  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
  </svg>
);

export default ErrorPage;
